import { render } from "./NewSensor.vue?vue&type=template&id=64a59a56&scoped=true"
import script from "./NewSensor.vue?vue&type=script&lang=js"
export * from "./NewSensor.vue?vue&type=script&lang=js"

import "./NewSensor.vue?vue&type=style&index=0&id=64a59a56&lang=scss&scoped=true"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a59a56"],['__file',"src/components/sensor/NewSensor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64a59a56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64a59a56', __exports__)) {
    console.log('reload')
    api.reload('64a59a56', __exports__)
  }
  
  module.hot.accept("./NewSensor.vue?vue&type=template&id=64a59a56&scoped=true", () => {
    console.log('re-render')
    api.rerender('64a59a56', render)
  })

}


export default __exports__